import { useMemo } from 'react';

import { useGracePeriodFieldsStateStore } from '../GracePeriod/stores';
import { usePayClaimsFieldsStateStore } from '../PayClaims/stores';

export default () => {
  const gracePeriodStore = useGracePeriodFieldsStateStore((state) => state.state);
  const payClaimsStore = usePayClaimsFieldsStateStore((state) => state.state);

  const state = useMemo(() => ({
    ...gracePeriodStore,
    ...payClaimsStore,
  }), [gracePeriodStore, payClaimsStore]);
  return state;
};
